import { IWebchatTokensRepository } from 'modules/webchat/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import CallbellWebchatTokensRepository from './implementations/CallbellWebchatTokensRepository';

let instance: IWebchatTokensRepository | null = null;

export default function makeWebchatTokensRepository() {
  if (!instance) {
    instance = new CallbellWebchatTokensRepository(makeHTTPProvider());
  }

  return instance;
}
